import { PlusOutlined } from "@ant-design/icons";
import {
  Upload,
  Button,
  Form,
  message,
  Select,
} from "antd";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import XLSX from "xlsx";
import {
  addImportErrors,
  emptyImportErrors,
  saveImportedParkings
} from "../../actions/parking";
import i18n from "../../i18n";
import i18next from "i18next";

const mapDispatchToProps = (dispatch) => {
  return {
    saveImportedParkings: (saveObj) => dispatch(saveImportedParkings(saveObj)),
    addImportErrors: (errors) => dispatch(addImportErrors(errors)),
    emptyImportErrors: () => dispatch(emptyImportErrors()),
  };
};
class ConnectedWizardExcelImportParking extends Component {
  state = {
    parkings: [],
    newParkings: [],
    file: [],
    emptyFirstName: [],
    emptyLastName: [],
    badEmail: [],
    duplicatedEmail: [],
    selectedParkingGroupId: null,
  };

  componentDidMount = async () => {
  };

  removeFile = () => {
    this.setState({
      file: [],
      newParkings: [],
      emptyFirstName: [],
      emptyLastName: [],
      badEmail: [],
      duplicatedEmail: [],
    });
  };

  beforeUpload = async (file) => {
    const workbook = XLSX.read(await file.arrayBuffer(), { type: "buffer" });
    const sheet_name_list = workbook.SheetNames;
    const result = XLSX.utils.sheet_to_json(
      workbook.Sheets[sheet_name_list[0]]
    );

    console.log("beforeUpload result", result);

    let parkingsToSave = [];
    await i18next.loadLanguages(["en", "de", "hu"]);

    const languages = ["en", "de", "hu"];
    const parkingNames = languages.map((lang) => {
      return i18n.t("building-room-type-name-parking", {
        lng: lang,
      });
    });
    const actives = languages.map((lang) => {
      return i18n.t("proximity-card-active-input-label", {
        lng: lang,
      });
    });
    const duplicates = result.map((parking) => {
      let parkingName = "";
      let parkingNameTr = "";
      parkingNames.forEach((parkingNametranslation) => {
        if (parking[parkingNametranslation]) {
          parkingName = parking[parkingNametranslation];
          parkingNameTr = parkingNametranslation;
        }
      });
      return {
        number: result.filter((parking2) => parking2[parkingNameTr] === parkingName).length,
        parkingName: parking[parkingNameTr],
      };
    });

    for (const parking in result) {
      let parkingToSave = {
      };
      parkingNames.forEach((parkingName) => {
        if (result[parking][parkingName]) {
          parkingToSave.parking = result[parking][parkingName];
        }
      });
      actives.forEach((activeTranslation) => {
        if (result[parking][activeTranslation]) {
          parkingToSave.active = result[parking][activeTranslation];
        }
      });

      if (!parkingToSave.parking) {
        console.error("parking name error", parkingToSave)
      } else if (duplicates.find(
            (duplicate) =>
              duplicate.parkingName === parkingToSave.parking && duplicate.number > 1
          )) {
          console.log("duplicate error", parkingToSave);
          //userToSave.index = parseInt(user) + 1;
          /*
          this.setState({
            duplicatedEmail: [...this.state.duplicatedEmail, userToSave],
          });
          */
      } else {
        parkingsToSave = [...parkingsToSave, parkingToSave];
      }
    }

    console.log(parkingsToSave);

    this.setState({ file: [file], newParkings: parkingsToSave });
    return false;
  };

  importData = async () => {
    await this.saveParkings();
  };

  handleParkingGroupSlect = async (event) => {
    this.setState({
      selectedParkingGroupId: event,
    });
  };

  saveParkings = async () => {
    console.log(this.state.selectedParkingGroupId)
    const saveObj = {
      parkings: this.state.newParkings,
      parkingGroupId: this.state.selectedParkingGroupId,
    };
    /*
    if (this.state.parkings.length === 0) {
      this.props.next();
    } else {
    */
    
    this.props.emptyImportErrors();
    await this.props.saveImportedParkings(saveObj);
    console.log("saveStatus: " + this.props.saveStatus);
    console.log("message: ",  this.props.message);
    if (this.props.saveStatus) {
      message.success("Parkolási adatok sikeresen elmentve");
      setTimeout(() => {
        this.props.next();
      }, 2000); 
    } else {
      if (this.props.message?.code && this.props.message.code === 1003) {
        message.error(
          `${this.props.t("wizard-excel-import-emailexists")} ${this.props.message.data.email
          }!`,
          2
        );
      } else if (this.props.message?.message && this.props.message?.data) {
        message.error(this.props.message.message + " " + this.props.message.data, 5);
      } else if (this.props.message?.message) {
        message.error(this.props.message.message, 5);
      }
    }

    //}
  };

  render() {
    const dummyRequest = ({ file, onSuccess }) => {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    };
    return (
      <div>
        <div style={{ textAlign: "center" }}>
          {this.props.user.officeId && (
            <>
              <Form.Item
                name="selectedParkingGroupId"
                label={"Kérem válasszon parkolási csoportot"}
                rules={[]}
              >
                <Select
                  style={{ width: "15em" }}
                  onChange={(event) => this.handleParkingGroupSlect(event)}
                  value={this.state.selectedParkingGroupId}
                >
                  {this.props.parkingGroups.map((parkingGroup) => {
                    return (
                      <Select.Option key={parkingGroup.id} value={parkingGroup.id}>
                        {parkingGroup.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </>
          )}
          <div style={{ margin: "1em", textAlign: "left" }}>
            <Upload.Dragger
              name="file"
              multiple={false}
              onRemove={this.removeFile}
              accept=".xlsx"
              beforeUpload={this.beforeUpload}
              fileList={this.state.file}
              showUploadList={{
                showDownloadIcon: false,
                showPreviewIcon: false,
              }}
              customRequest={dummyRequest}
            >
              <p
                className="ant-upload-drag-icon"
                style={{ textAlign: "center" }}
              >
                <PlusOutlined />
              </p>
              <p
                className="ant-upload-text"
                style={{ color: "#00b7ae", textAlign: "center" }}
              >
                {this.props.t("wizard-excel-upload")}
              </p>
            </Upload.Dragger>
          </div>
          {this.state.newParkings.length === 0 && this.state.file.length !== 0 && (
            <div style={{ color: "#ff4d4f" }}>
              {this.props.t("all-entry-isbad")}
            </div>
          )}
          <div style={{ margin: "1em" }}>
            <Button
              onClick={this.importData}
              type="primary"
              style={{ width: "65%" }}
              disabled={
                (this.props.user.officeId && !this.state.selectedParkingGroupId)
                || this.state.file.length === 0 || this.state.newParkings.length === 0
              }
            >
              {this.props.t("wizard-excel-import")}
            </Button>
          </div>
          <div style={{ margin: "1em" }}>
            <Button onClick={this.props.back} style={{ width: "65%" }}>
              {this.props.t("back-button-label")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.loginReducer.user,
  message: state.parkingReducer.message,
  saveStatus: state.parkingReducer.saveStatus,
});
const WizardExcelImportParking = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectedWizardExcelImportParking)
);
export default WizardExcelImportParking;
